import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";

const initialState = {
  loading: false,
  categoryListData: [],
  error: "",
  success: false,
  status: "",
};

const fetchCategoryList = createAsyncThunk("fetch/categoryList", async () => {
  try {
    const result = await axios.get(
      "https://apac.api.capillarytech.com/mobile/v2/api/marvel/rewards/categorie"
    );

    return result?.data;
  } catch (err) {
    console.log(err);
  }
});

const categoryListSlice = createSlice({
  name: "category-list",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchCategoryList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchCategoryList.fulfilled, (state, action) => {
      // console.log(action.payload, "Category list");
      state.loading = false;
      state.categoryListData = action?.payload?.categoryList;
      state.success = action.payload?.status?.success;
      state.error = "";
    });
    builder.addCase(fetchCategoryList.rejected, (state, action) => {
      state.loading = false;
      state.categoryListData = [];
      state.error = action.error.message;
    });
  },
});

export default categoryListSlice.reducer;
export { fetchCategoryList };
